var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhitePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.77387 5.98496C1.77387 8.31278 3.62461 10.1955 5.91291 10.1955C7.21966 10.1955 8.37859 9.58195 9.13544 8.61955L10.6728 9.53985C9.59665 11.0316 7.86417 12 5.90699 12C2.64307 12 0 9.30526 0 5.98496C0 2.86316 2.32969 0.300752 5.32162 0V1.82256C3.31714 2.11729 1.77387 3.86165 1.77387 5.98496ZM6.5042 0V1.82256C8.50867 2.11729 10.0519 3.86165 10.0519 5.98496C10.0519 6.52632 9.94551 7.03759 9.76812 7.51278L11.3055 8.43308C11.6366 7.68722 11.8258 6.85714 11.8258 5.98496C11.8258 2.86917 9.49022 0.300752 6.5042 0ZM5.32162 3.57895V5.38346H3.54774V6.58647H5.32162V8.39098H6.5042V6.58647H8.27807V5.38346H6.5042V3.57895H5.32162Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlus);
export default __webpack_public_path__ + "static/media/white-plus.b033fcd31bdcfe3458a67027942eb5c8.svg";
export { ForwardRef as ReactComponent };